import { CustomEdge } from "./CustomV2";

export const edgeTypes = {
  customEdge: CustomEdge,
} as const;
